import script from "./ButtonAccentPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonAccentPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonAccentPrimary.vue?vue&type=style&index=0&id=d31975d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d31975d6"]])

export default __exports__